import KnowMappedWordmark from "../assets/knowmapped-wordmark-light.svg";
import KnowMappedWordmarkSource from "../assets/knowmapped-wordmark-light.svg?raw";
import KnowMappedWordmarkDark from "../assets/knowmapped-wordmark-dark.svg";
import KnowMappedWordmarkDarkSource from "../assets/knowmapped-wordmark-dark.svg?raw";
import { isDarkBackground } from "./mapThemes.js";

// Keep this in one place so the watermark can be tuned without changing each
// public-map, embed, and export renderer independently.
export const KNOWMAPPED_WATERMARK_OPACITY = 0.72;
export const KNOWMAPPED_WATERMARK_WIDTH = 177;
export const KNOWMAPPED_WATERMARK_ASSET = KnowMappedWordmark;
export const KNOWMAPPED_WATERMARK_LINK = "https://knowmapped.com";
// Native SVG exports are standalone files, so embed the wordmark rather than
// leaving an asset URL that would break when the export is opened elsewhere.
export const KNOWMAPPED_WATERMARK_DATA_URI = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(KnowMappedWordmarkSource)}`;
export const KNOWMAPPED_WATERMARK_DARK_ASSET = KnowMappedWordmarkDark;
export const KNOWMAPPED_WATERMARK_DARK_DATA_URI = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(KnowMappedWordmarkDarkSource)}`;

export function watermarkForBackground(background, { standalone = false } = {}) {
  const dark = isDarkBackground(background);
  return {
    asset: dark ? KNOWMAPPED_WATERMARK_DARK_ASSET : KNOWMAPPED_WATERMARK_ASSET,
    dataUri: dark ? KNOWMAPPED_WATERMARK_DARK_DATA_URI : KNOWMAPPED_WATERMARK_DATA_URI,
    dark,
    standalone,
  };
}

export function normalizeWatermarkOpacity(value = KNOWMAPPED_WATERMARK_OPACITY) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return KNOWMAPPED_WATERMARK_OPACITY;
  return Math.min(1, Math.max(0, parsed));
}
